var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvestmentsAuction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "32px",
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Basics",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Basics/Icons",
    transform: "translate(-5026.000000, -368.000000)",
    fill: "#262626"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Investments/Auction",
    transform: "translate(5026.000000, 368.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30,20.9999655 L30,27.9999897 C30,29.6569954 28.657,31 27,31 L27,31 L6,31 C4.343,31 3,29.6569954 3,27.9999897 L3,27.9999897 L3,20.9999655 L30,20.9999655 Z M27,23.9999759 L24,23.9999759 L24,27.9999897 L27,27.9999897 L27,23.9999759 Z M21,23.9999759 L18,23.9999759 L18,27.9999897 L21,27.9999897 L21,23.9999759 Z M15,23.9999759 L12,23.9999759 L12,27.9999897 L15,27.9999897 L15,23.9999759 Z M9,23.9999759 L6,23.9999759 L6,27.9999897 L9,27.9999897 L9,23.9999759 Z M16.5,6.99991724 C19.572,6.99991724 22.141,9.1349246 22.819,11.9999345 L22.819,11.9999345 L24,11.9999345 L24,14.9999448 L23,14.9999448 L23,18.9999586 L20,18.9999586 L20,14.9999448 L18,14.9999448 L18,18.9999586 L15,18.9999586 L15,14.9999448 L13,14.9999448 L13,18.9999586 L10,18.9999586 L10,14.9999448 L9,14.9999448 L9,11.9999345 L10.181,11.9999345 C10.859,9.1349246 13.427,6.99991724 16.5,6.99991724 Z M16.5,2 C17.563,2 18.582,2.22100076 19.506,2.62300215 C20.617,3.05900365 21.815,3.22200421 23,3.09900379 L23,3.09900379 L23,7.09901758 C21.815,7.22201801 20.617,7.05901744 19.506,6.62301594 C18.582,6.22101456 17.563,6.00001379 16.5,6.00001379 C16.332,6.00001379 16.166,6.00501381 16,6.01601385 L16,6.01601385 L16,2.01600006 C16.166,2.00500002 16.332,2 16.5,2 Z",
    id: 30
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvestmentsAuction);
export default __webpack_public_path__ + "static/media/investments-auction.d016e6f7.svg";
export { ForwardRef as ReactComponent };